import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#e80962' },
    secondary: { main: '#ffffff' },
    background: { default: '#ffffff' },
    text: { primary: '#1b1b1b' }
  },
  typography: {
    h1: { fontWeight: 800, fontSize: '2.5rem' },
    h2: { fontWeight: 700, fontSize: '2rem' },
    h3: { fontWeight: 700, fontSize: '1.6rem' },
    button: { textTransform: 'none', fontWeight: 700 }
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: '#ffffff', color: '#1b1b1b' } } }
  }
});

export default theme;
